(function(module) {
    'use strict';

    function appIconCtrl(envService) {
        this.$onInit = () => {
            this.appsBaseUrl = envService.read('APPS_URI');
        };
    }

    module
        .component('appIcon', {
            templateUrl: '/js/components/app-icon/app-icon.html',
            controller: appIconCtrl,
            bindings: {
                slug: '<',
                styles: '<'
            },
        });
})(angular.module('rocket.components'));
